import { useFormik } from "formik";
import React, { useEffect, useState, useRef } from "react";
import OrderSummary from "../orderSummary/OrderSummary";
import * as Yup from "yup";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useCreateOrderMutation } from "../../store/api/OrderSlice";
import toast from "react-hot-toast";
import useDebounce from "../../hooks/useDebounce";
import {
  useFetchAllShippingMethodQuery,
  useFetchShippingByCodeQuery,
} from "../../store/api/ShippingSlice";
import {
  useCheckUserMutation,
  useLoginUserMutation,
  useRegisterUserMutation,
} from "../../store/api/AuthSlice";
import { setAuthData } from "../../store/reducers/auth";
import { isLoginAction } from "../../store/reducers/isOpenSlice";
import States from "../../fakeData/Data";
import AgeChecker from "../login/AgeChecker";

function Checkout() {
  const { data, error, isLoading } = useFetchAllShippingMethodQuery();
  const shippingMethod = data?.find((option) => option.status === "Show");
  const shippingCostNew = shippingMethod?.cost || 0; // Default to 0 if no
  const shippingThreshhold = shippingMethod?.freeShippingThreshold;
  const [createOrder] = useCreateOrderMutation();
  const [PostalCodevalues, setPostalCodevalues] = useState(0);
  const [shippingCost, setShippingCost] = useState(0);
  const navigate = useNavigate();
  const { ...item } = useSelector((state) => state.cart);
  const vendor = item?.cartItems?.[0]?.author?._id || "No Vendor";
  const cartTotalAmount = useSelector((state) => state.cart.cartTotalAmount);
const [redirectMessage, setRedirectMessage] = useState(false);
  const finalShippingCost =
    cartTotalAmount >= shippingThreshhold ? 0 : shippingCostNew;

  const [registerUser] = useRegisterUserMutation();
  const [loginUser] = useLoginUserMutation();
  const [checkUser] = useCheckUserMutation();
  const [isAgeVerified, setIsAgeVerified] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const paymentLockRef = useRef(false);

  const dispatch = useDispatch();

  // if (!vendor) {
  //   navigate("/");
  //   toast.alert("This Product is out of Stock");
  // }

  const savedCheckoutData = JSON.parse(
    localStorage.getItem("checkoutForm") || "{}"
  );

  const initialValues = {
    name: savedCheckoutData.name || "",
    email: savedCheckoutData.email || "",
    phoneNumber: savedCheckoutData.phoneNumber || "",
    country: savedCheckoutData.country || "USA",
    streetAddress: savedCheckoutData.streetAddress || "",
    city: savedCheckoutData.city || "",
    state: savedCheckoutData.state || "",
    companyName: savedCheckoutData.companyName || "",
    zipCode: savedCheckoutData.zipCode || "",

    // Shipping details
    streetAddress2: savedCheckoutData.streetAddress2 || "",
    city2: savedCheckoutData.city2 || "",
    state2: savedCheckoutData.state2 || "",
    zipCode2: savedCheckoutData.zipCode2 || "",

    // Payment
    paymentMethod: "credit card",

    // NEVER save card details
    cardNumber: "",
    expirationDate: "",
    securityCode: "",

    // Dynamic order values
    subTotal: item?.cartTotalAmount || 0,
    shippingCost: shippingCostNew || 0,
    shippingOption: "Credit Card",
    total: (item?.cartTotalAmount || 0) + (shippingCostNew || 0),
    status: "Processing",
    cart: item,
  };
  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),

    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),

    phoneNumber: Yup.string()
      .matches(/^\d{10}$/, "Phone number must be 10 digits")
      .required("Phone number is required"),

    country: Yup.string().required("Country is required"),

    streetAddress: Yup.string().required("Street address is required"),

    streetAddress2: Yup.string().required("Street address is required"),

    city: Yup.string().required("City is required"),

    city2: Yup.string().required("City is required"),

    state: Yup.string()
      .required("State is required")
      .oneOf(States, "Please select a valid state"),

    state2: Yup.string()
      .required("State is required")
      .oneOf(States, "Please select a valid state"),

    companyName: Yup.string(),

    zipCode: Yup.string()
      .matches(/^\d{5}$/, "ZIP/Postal code must be 5 digits")
      .required("ZIP/Postal code is required"),

    zipCode2: Yup.string()
      .matches(/^\d{5}$/, "ZIP/Postal code must be 5 digits")
      .required("ZIP/Postal code is required"),

    shippingOption: Yup.string().required(
      "Shipping option is required"
    ),

    paymentMethod: Yup.string().required(
      "Payment method is required"
    ),

    cardNumber: Yup.string()
      .matches(/^\d{16}$/, "Card number must be exactly 16 digits")
      .required("Card number is required"),

    expirationDate: Yup.string()
      .matches(
        /^(0[1-9]|1[0-2])\/\d{2}$/,
        "Invalid expiration date format (MM/YY)"
      )
      .required("Expiration date is required"),

    securityCode: Yup.string()
      .matches(/^\d{3}$/, "Security code must be 3 digits")
      .required("Security code is required"),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,

    onSubmit: async (values) => {
      if (paymentLockRef.current || isProcessing) {
        console.log("Duplicate payment submit blocked");
        return;
      }

      paymentLockRef.current = true;

      console.log("=================================");
      console.log("PAYMENT FLOW STARTED");
      console.log("FORM VALUES:", values);

      setIsProcessing(true);

      toast.loading(
        "Please wait while your order is being processed...",
        {
          id: "processing-order",
        }
      );

      try {

        const total = Number(
          (values.subTotal + finalShippingCost).toFixed(2)
        );
        let checkoutSessionId = localStorage.getItem("checkoutSessionId");

        if (!checkoutSessionId) {
          checkoutSessionId = crypto.randomUUID();
          localStorage.setItem("checkoutSessionId", checkoutSessionId);
        }

        const email = values.email;

        const generatedPassword = "AutoGeneratedPass123";



        const authData = {
          clientKey:
            "2evEQYJM6bebqEgcCM27K82hQyjy6bUdg3V7e2T6a9PBpX5MDdRwV47Trb3vmvDv",
          apiLoginID: "462qu7AKY",
        };

        console.log("AUTH DATA:", authData);

        const [expMonth, expYearShort] =
          values.expirationDate.split("/");

        const cardData = {
          cardNumber: values.cardNumber.replace(/\s/g, ""),
          month: expMonth,
          year: "20" + expYearShort,
          cardCode: values.securityCode,
        };

        console.log("CARD DATA:", cardData);

        const secureData = {
          authData,
          cardData,
        };

        console.log("SECURE DATA:", secureData);

        // CHECK ACCEPT JS
        console.log("WINDOW ACCEPT:", window.Accept);

        if (!window.Accept) {

          toast.dismiss("processing-order");

          setIsProcessing(false);
          paymentLockRef.current = false;

          toast.error(
            "Accept.js library not loaded"
          );

          console.error(
            "Accept.js library missing"
          );

          return;
        }

        // ACCEPT JS TOKENIZATION
        window.Accept.dispatchData(
          secureData,

          async function responseHandler(response) {

            console.log(
              "FULL ACCEPT RESPONSE:",
              response
            );

            // ACCEPT ERROR
            if (
              response.messages.resultCode === "Error"
            ) {

              console.log(
                "ACCEPT ERROR:",
                response.messages.message
              );

              toast.dismiss("processing-order");

              setIsProcessing(false);
              paymentLockRef.current = false;

              response.messages.message.forEach(
                (msg) => {

                  console.error(
                    "ACCEPT ERROR MESSAGE:",
                    msg
                  );

                  toast.error(msg.text);
                }
              );

              return;
            }

            console.log(
              "TOKENIZATION SUCCESS"
            );

            console.log(
              "OPAQUE DATA:",
              response.opaqueData
            );

            const opaqueData =
              response.opaqueData;

            try {

              // CHECK USER
              console.log(
                "CHECKING USER..."
              );

              let userId;

              const existingUserResponse =
                await checkUser({
                  email,
                }).unwrap();

              console.log(
                "CHECK USER RESPONSE:",
                existingUserResponse
              );

              // EXISTING USER
              if (
                existingUserResponse?.exists
              ) {

                userId =
                  existingUserResponse?.userId;

                console.log(
                  "EXISTING USER:",
                  userId
                );

              } else {

                // REGISTER USER
                console.log(
                  "REGISTERING USER..."
                );

                const registerResponse =
                  await registerUser({
                    name: values.name,
                    email,
                    password:
                      generatedPassword,
                  }).unwrap();

                console.log(
                  "REGISTER RESPONSE:",
                  registerResponse
                );

                userId =
                  registerResponse?._id;
              }

              const items = values.cart?.cartItems || [];
              console.log("FULL CART ITEMS DEBUG:", JSON.stringify(items, null, 2));

              console.log("QUANTITY FIELD CHECK:", items.map((item) => ({
                title: item.title,
                quantity: item.quantity,
                qty: item.qty,
                cartQuantity: item.cartQuantity,
                count: item.count,
                stock: item.stock,
                productQuantity: item.productQuantity,
                selectedQuantity: item.selectedQuantity,
                price: item.price,
              })));

              console.log(
                "CART ITEMS:",
                items
              );

              // PAYMENT PAYLOAD
              const paymentPayload = {
                checkoutSessionId,
                opaqueData,

                amount: Number(
                  total.toFixed(2)
                ),

                name: values.name,

                email: values.email,

                phoneNumber:
                  values.phoneNumber,

                country: values.country,

                streetAddress:
                  values.streetAddress,

                city: values.city,

                state: values.state,

                zipCode: values.zipCode,

                companyName:
                  values.companyName,

                streetAddress2:
                  values.streetAddress2,

                city2: values.city2,

                state2: values.state2,

                zipCode2:
                  values.zipCode2,

                items: items.map(
                  (item) => ({
                    id: item._id,

                    name: item.title,

                    description:
                      item.description ||
                      item.short_description ||
                      "",

                    quantity:
                      item.quantity || 1,

                    price:
                      item.price || 0,
                  })
                ),
              };

              console.log(
                "PAYMENT PAYLOAD:",
                paymentPayload
              );

              console.log(
                "CALLING BACKEND..."
              );

              // BACKEND API CALL
              const paymentRes = await fetch(
                "https://api.pufframa.com/api/payment/charge",
                {
                  method: "POST",

                  headers: {
                    "Content-Type":
                      "application/json",
                  },

                  body: JSON.stringify(
                    paymentPayload
                  ),
                }
              );

              console.log(
                "PAYMENT RESPONSE STATUS:",
                paymentRes.status
              );

              const paymentResult =
                await paymentRes.json();

              console.log(
                "PAYMENT RESULT:",
                paymentResult
              );

              // PAYMENT FAILED
              if (
                !paymentResult.success
              ) {

                throw new Error(
                  paymentResult.error ||
                  "Payment failed"
                );
              }

              console.log(
                "PAYMENT SUCCESS"
              );

              // CREATE ORDER
              console.log(
                "CREATING ORDER..."
              );

              const {
                cardNumber,
                expirationDate,
                securityCode,
                ...safeOrderValues
              } = values;

              const orderResponse = await createOrder({
                ...safeOrderValues,
                userId,
                shippingCost: finalShippingCost,
                total,
                checkoutSessionId,
                transactionId: paymentResult.transactionId,
                paymentStatus: "paid",
              }).unwrap();
              console.log(
                "ORDER RESPONSE:",
                orderResponse
              );

              if (
                !orderResponse?.success
              ) {

                throw new Error(
                  "Order submission failed"
                );
              }

              toast.dismiss(
                "processing-order"
              );

              toast.success(
                "Order placed successfully!"
              );
              localStorage.removeItem("checkoutSessionId");
              // AUTO LOGIN
              console.log(
                "AUTO LOGIN START..."
              );

              const loginResponse =
                await loginUser({
                  email,

                  password:
                    generatedPassword,
                }).unwrap();

              console.log(
                "LOGIN RESPONSE:",
                loginResponse
              );

              if (
                loginResponse?.token &&
                loginResponse?.name &&
                loginResponse?.email
              ) {

                dispatch(
                  setAuthData({
                    token:
                      loginResponse.token,

                    user: {
                      _id:
                        loginResponse._id,

                      name:
                        loginResponse.name,

                      email:
                        loginResponse.email,
                    },
                  })
                );

                localStorage.setItem(
                  "token",
                  loginResponse.token
                );

                dispatch(
                  isLoginAction(false)
                );
              }

              setIsProcessing(false);
              paymentLockRef.current = false;

              console.log(
                "REDIRECTING..."
              );

              navigate(
                "/user/dashboard"
              );

            } catch (error) {

              console.error(
                "PAYMENT FLOW ERROR:",
                error
              );

              toast.dismiss(
                "processing-order"
              );

              setIsProcessing(false);
              paymentLockRef.current = false;

              toast.error(
                error.message ||
                "Something went wrong"
              );
            }
          }
        );

      } catch (error) {

        console.error(
          "MAIN SUBMIT ERROR:",
          error
        );

        toast.dismiss(
          "processing-order"
        );

        setIsProcessing(false);
        paymentLockRef.current = false;

        toast.error(
          error.message ||
          "Checkout failed"
        );
      }
    },
  });
const handleRedirect = (e) => {
  e.preventDefault();

  setRedirectMessage(true);

  setTimeout(() => {
    window.location.href = "https://smokeprawns.com";
  }, 5000);
};
  useEffect(() => {

    const {
      cardNumber,
      expirationDate,
      securityCode,
      ...safeValues
    } = formik.values;

    localStorage.setItem(
      "checkoutForm",
      JSON.stringify(safeValues)
    );

  }, [formik.values]);

  useEffect(() => {

    if (
      localStorage.getItem(
        "isAgeVerified"
      ) === "true"
    ) {

      setIsAgeVerified(true);
    }

  }, []);
  return (
    <div className="bg-black-50">
      <AgeChecker />
      <div className="mx-auto max-w-screen-2xl px-3 sm:px-10">
        <div className="my-10">
          <div className="mt-5 md:mt-0 md:col-span-2">
            <form onSubmit={formik.handleSubmit}>
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
                <div className="lg:col-span-2">
                  {" "}
                  <div>
                    <div>
                      <h2 className="font-semibold text-xl text-base text-black-700 pb-10">
                        Billing Details
                      </h2>
                      <div className="grid grid-cols-6 gap-6">
                        {/* Email Address */}
                        <div className="col-span-6 sm:col-span-3">
                          <label
                            htmlFor="email"
                            className="block text-black-500 font-semibold font-medium text-sm leading-none mb-2"
                          >
                            Email Address <span className="text-red-500">*</span>
                          </label>
                          <div className="relative">
                            <input
                              className={`py-2 px-4 md:px-5 w-full appearance-none border text-sm opacity-75 text-input rounded-md placeholder-body min-h-12 transition duration-200 focus:ring-0 ease-in-out bg:white border-black-200 focus:outline-none focus:border-emerald-500 h-11 md:h-12 ${formik.touched.email && formik.errors.email
                                ? "border-red-500"
                                : ""
                                }`}
                              id="email"
                              name="email"
                              type="email"
                              placeholder="Enter your email"
                              value={formik.values.email}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                          </div>
                          {formik.errors.email && formik.touched.email && (
                            <span className="text-red-400 text-sm mt-2">
                              {formik.errors.email}
                            </span>
                          )}
                        </div>

                        {/* First Name */}
                        <div className="col-span-6 sm:col-span-3">
                          <label
                            htmlFor="email"
                            className="block text-black-500 font-semibold font-medium text-sm leading-none mb-2"
                          >
                            Name <span className="text-red-500">*</span>
                          </label>
                          <input
                            className={`py-2 px-4 md:px-5 w-full appearance-none border text-sm opacity-75 text-input rounded-md placeholder-body min-h-12 transition duration-200 focus:ring-0 ease-in-out bg:white border-black-200 focus:outline-none focus:border-emerald-500 h-11 md:h-12 ${formik.touched.name && formik.errors.name
                              ? "border-red-500"
                              : ""
                              }`}
                            type="text"
                            name="name"
                            value={formik.values.name}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.name && formik.errors.name && (
                            <div className="error">{formik.errors.name}</div>
                          )}
                        </div>

                        {/* Company Name */}
                        <div className="col-span-6 sm:col-span-3">
                          <label
                            htmlFor="companyName"
                            className="block text-black-500 font-semibold font-medium text-sm leading-none mb-2"
                          >
                            Company Name (optional)
                          </label>
                          <div className="relative">
                            <input
                              className="py-2 px-4 md:px-5 w-full appearance-none border text-sm opacity-75 text-input rounded-md placeholder-body min-h-12 transition duration-200 focus:ring-0 ease-in-out bg-white border-black-200 focus:outline-none focus:border-emerald-500 h-11 md:h-12"
                              id="companyName"
                              name="companyName"
                              placeholder=""
                              value={formik.values.companyName}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                          </div>
                        </div>

                        {/* Country / Region */}
                        <div className="col-span-6 sm:col-span-3">
                          <label
                            htmlFor="country"
                            className="block text-black-500 font-semibold font-medium text-sm leading-none mb-2"
                          >
                            Country
                          </label>
                          <div className="relative">
                            <select
                              as="select"
                              className="py-2 px-4 md:px-5 w-full appearance-none border text-sm opacity-75 text-input rounded-md min-h-12 transition duration-200 focus:ring-0 ease-in-out bg:white border-black-200 focus:outline-none focus:border-emerald-500 h-11 md:h-12"
                              id="country"
                              name="country"
                              value={formik.values.country}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            >
                              <option values="USA">United States</option>
                            </select>
                          </div>

                          {formik.errors.country && formik.touched.country && (
                            <span className="text-red-400 text-sm mt-2">
                              {formik.errors.country}
                            </span>
                          )}
                        </div>

                        {/* Street Address */}
                        <div className="col-span-6">
                          <label
                            htmlFor="streetAddress"
                            className="block text-black-500 font-semibold font-medium text-sm leading-none mb-2"
                          >
                            Street Address <span className="text-red-500">*</span>
                          </label>
                          <div className="relative">
                            <input
                              type="text"
                              className={`py-2 px-4 md:px-5 w-full appearance-none border text-sm opacity-75 text-input rounded-md placeholder-body min-h-12 transition duration-200 focus:ring-0 ease-in-out bg:white border-black-200 focus:outline-none focus:border-emerald-500 h-11 md:h-12 ${formik.touched.streetAddress &&
                                formik.errors.streetAddress
                                ? "border-red-500"
                                : ""
                                }`}
                              id="streetAddress"
                              name="streetAddress"
                              placeholder="House number and street name"
                              value={formik.values.streetAddress}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                          </div>
                          {formik.errors.streetAddress &&
                            formik.touched.streetAddress && (
                              <span className="text-red-400 text-sm mt-2">
                                {formik.errors.streetAddress}
                              </span>
                            )}
                        </div>
                        {/* City -- Town */}
                        <div className="col-span-6 sm:col-span-3">
                          <label
                            htmlFor="city"
                            className="block text-black-500 font-semibold font-medium text-sm leading-none mb-2"
                          >
                            Town / City <span className="text-red-500">*</span>
                          </label>
                          <div className="relative">
                            <input
                              type="text"
                              className={`py-2 px-4 md:px-5 w-full appearance-none border text-sm opacity-75 text-input rounded-md placeholder-body min-h-12 transition duration-200 focus:ring-0 ease-in-out bg:white border-black-200 focus:outline-none focus:border-emerald-500 h-11 md:h-12 ${formik.touched.city && formik.errors.city
                                ? "border-red-500"
                                : ""
                                }`}
                              id="city"
                              name="city"
                              placeholder="Enter city"
                              value={formik.values.city}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                          </div>
                          {formik.errors.city && formik.touched.city && (
                            <span className="text-red-400 text-sm mt-2">
                              {formik.errors.city}
                            </span>
                          )}
                        </div>


                        <div className="col-span-6 sm:col-span-3">
                          <label
                            htmlFor="state"
                            className="block text-black-500 font-semibold font-medium text-sm leading-none mb-2"
                          >
                            State <span className="text-red-500">*</span>
                          </label>
                          <div className="relative">
                            <select
                              id="state"
                              name="state"
                              value={formik.values.state}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              className={`py-2 px-4 md:px-5 w-full appearance-none border text-sm opacity-75 text-input rounded-md placeholder-body min-h-12 transition duration-200 focus:ring-0 ease-in-out bg-white border-black-200 focus:outline-none focus:border-emerald-500 h-11 md:h-12 ${formik.touched.state && formik.errors.state
                                ? "border-red-500"
                                : ""
                                }`}
                            >
                              <option value="">Select a state</option>
                              {States.map((state) => (
                                <option key={state} value={state}>
                                  {state}
                                </option>
                              ))}
                            </select>
                          </div>
                          {formik.errors.state && formik.touched.state && (
                            <span className="text-red-400 text-sm mt-2">
                              {formik.errors.state}
                            </span>
                          )}
                        </div>


                        {/* ZIP Code */}
                        <div className="col-span-6 sm:col-span-3 ">
                          <label
                            htmlFor="zipCode"
                            className="block text-black-500 font-semibold font-medium text-sm leading-none mb-2"
                          >
                            ZIP / Postal <span className="text-red-500">*</span>
                          </label>
                          <div className="relative">
                            <input
                              type="number"
                              className={`py-2 px-4 md:px-5 w-full appearance-none border text-sm opacity-75 text-input rounded-md placeholder-body min-h-12 transition duration-200 focus:ring-0 ease-in-out bg:white border-black-200 focus:outline-none focus:border-emerald-500 h-11 md:h-12 ${formik.touched.zipCode && formik.errors.zipCode
                                ? "border-red-500"
                                : ""
                                }`}
                              id="zipCode"
                              name="zipCode"
                              placeholder="Enter ZIP/Postal code"
                              value={formik.values.zipCode}
                              onChange={(e) => {
                                formik.handleChange(e); // Formik's handleChange
                                // setPostalCodevalues(e.target.value);
                              }}
                              onBlur={formik.handleBlur} // Handle blur event
                            />
                          </div>
                          {formik.errors.zipCode && formik.touched.zipCode && (
                            <span className="text-red-400 text-sm mt-2">
                              {formik.errors.zipCode}
                            </span>
                          )}
                        </div>
                        {/* Phone Number */}
                        <div className="col-span-6 sm:col-span-3">
                          <label
                            htmlFor="phoneNumber"
                            className="block text-black-500 font-semibold font-medium text-sm leading-none mb-2"
                          >
                            Phone Number <span className="text-red-500">*</span>
                          </label>
                          <div className="relative">
                            <input
                              type="number"
                              className={`py-2 px-4 md:px-5 w-full appearance-none border text-sm opacity-75 text-input rounded-md placeholder-body min-h-12 transition duration-200 focus:ring-0 ease-in-out bg:white border-black-200 focus:outline-none focus:border-emerald-500 h-11 md:h-12 ${formik.touched.phoneNumber &&
                                formik.errors.phoneNumber
                                ? "border-red-500"
                                : ""
                                }`}
                              id="phoneNumber"
                              name="phoneNumber"
                              placeholder="Enter your phone number"
                              value={formik.values.phoneNumber}
                              onChange={formik.handleChange} // Formik's handleChange
                              onBlur={formik.handleBlur} // Handle blur event
                            />
                          </div>
                          {formik.errors.phoneNumber &&
                            formik.touched.phoneNumber && (
                              <span className="text-red-400 text-sm mt-2">
                                {formik.errors.phoneNumber}
                                {/* Debugging error */}
                              </span>
                            )}
                        </div>
                        {/* -------------------new code ------------------------------- */}

                        <div className="col-span-6">
                          <div className="flex">
                            <label className="block text-black-500 font-semibold font-medium text-xl leading-none mb-2">
                              Ship to the same address
                            </label>
                            <input
                              className="-mt-1 ml-3"
                              type="checkbox"
                              id="sameAsBilling"
                              name="sameAsBilling"
                              onChange={(e) => {
                                if (e.target.checked) {
                                  formik.setValues({
                                    ...formik.values,
                                    streetAddress2: formik.values.streetAddress,
                                    city2: formik.values.city,
                                    state2: formik.values.state,
                                    zipCode2: formik.values.zipCode,
                                  });
                                } else {
                                  formik.setValues({
                                    ...formik.values,
                                    streetAddress2: "",
                                    city2: "",
                                    state2: "",
                                    zipCode2: "",
                                  });
                                }
                              }}
                            />
                          </div>
                        </div>
                        {/* Street Address */}
                        <div className="col-span-6">
                          <h4 className="pb-6">Shipping Details</h4>
                          <label
                            htmlFor="shippingStreetAddress"
                            className="block text-black-500 font-semibold font-medium text-sm leading-none mb-2 mt-4"
                          >
                            Street Address <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="text"
                            className={`py-2 px-4 md:px-5 w-full appearance-none border text-sm opacity-75 text-input rounded-md placeholder-body min-h-12 transition duration-200 focus:ring-0 ease-in-out bg:white border-black-200 focus:outline-none focus:border-emerald-500 h-11 md:h-12 ${formik.touched.streetAddress2 &&
                              formik.errors.streetAddress2
                              ? "border-red-500"
                              : ""
                              }`}
                            id="streetAddress2"
                            name="streetAddress2"
                            placeholder="House number and street name"
                            value={formik.values.streetAddress2}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.streetAddress2 &&
                            formik.errors.streetAddress2 && (
                              <p className="text-red-500 text-sm mt-1">
                                {formik.errors.streetAddress2}
                              </p>
                            )}
                        </div>

                        {/* City */}
                        <div className="col-span-6 sm:col-span-3">
                          <label
                            htmlFor="shippingCity"
                            className="block text-black-500 font-semibold font-medium text-sm leading-none mb-2"
                          >
                            Town / City <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="text"
                            className={`py-2 px-4 md:px-5 w-full appearance-none border text-sm opacity-75 text-input rounded-md placeholder-body min-h-12 transition duration-200 focus:ring-0 ease-in-out bg:white border-black-200 focus:outline-none focus:border-emerald-500 h-11 md:h-12 ${formik.touched.city2 && formik.errors.city2
                              ? "border-red-500"
                              : ""
                              }`}
                            id="city2"
                            name="city2"
                            placeholder="Enter city"
                            value={formik.values.city2}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.city2 && formik.errors.city2 && (
                            <p className="text-red-500 text-sm mt-1">
                              {formik.errors.city2}
                            </p>
                          )}
                        </div>

                        {/* State */}
                        <div className="col-span-6 sm:col-span-3">
                          <label
                            htmlFor="shippingState"
                            className="block text-black-500 font-semibold font-medium text-sm leading-none mb-2"
                          >
                            State<span className="text-red-500">*</span>
                          </label>
                          <div className="relative">
                            <select
                              id="state2"
                              name="state2"
                              value={formik.values.state2}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              className={`py-2 px-4 md:px-5 w-full appearance-none border text-sm opacity-75 text-input rounded-md placeholder-body min-h-12 transition duration-200 focus:ring-0 ease-in-out bg-white border-black-200 focus:outline-none focus:border-emerald-500 h-11 md:h-12 ${formik.touched.state2 && formik.errors.state2
                                ? "border-red-500"
                                : ""
                                }`}
                            >
                              <option value="">Select a state</option>
                              {States.map((state) => (
                                <option key={state} value={state}>
                                  {state}
                                </option>
                              ))}
                            </select>
                          </div>
                          {formik.errors.state2 && formik.touched.state2 && (
                            <span className="text-red-400 text-sm mt-2">
                              {formik.errors.state2}
                            </span>
                          )}
                        </div>

                        {/* ZIP Code */}
                        <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                          <label
                            htmlFor="shippingZipCode"
                            className="block text-black-500 font-semibold font-medium text-sm leading-none mb-2"
                          >
                            ZIP / Postal <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="number"
                            className={`py-2 px-4 md:px-5 w-full appearance-none border text-sm opacity-75 text-input rounded-md placeholder-body min-h-12 transition duration-200 focus:ring-0 ease-in-out bg-white border-black-200 focus:outline-none focus:border-emerald-500 h-11 md:h-12 ${formik.touched.zipCode2 && formik.errors.zipCode2
                              ? "border-red-500"
                              : ""
                              }`}
                            id="zipCode2"
                            name="zipCode2"
                            placeholder="Enter ZIP/Postal code"
                            value={formik.values.zipCode2}
                            onChange={(e) => formik.handleChange(e)}
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.zipCode2 &&
                            formik.errors.zipCode2 && (
                              <p className="text-red-500 text-sm mt-1">
                                {formik.errors.zipCode2}
                              </p>
                            )}
                        </div>
                      </div>
                      {/* Shipping Cost---- */}
                      <div className="hidden mt-2 mb-2">
                        <label className="block text-black-500 font-semibold font-medium text-sm leading-none mb-2">
                          Shipping Cost
                        </label>
                        <div className="hidden grid grid-cols-6 gap-6">
                          {data &&
                            data
                              .filter((option) => option.status === "Show")
                              .map((option, index) => (
                                <div
                                  key={index}
                                  className="col-span-6 sm:col-span-3"
                                >
                                  <div className="p-3 border border-black-200 bg-white rounded-md">
                                    <label className="cursor-pointer label">
                                      <div className="flex items-center justify-between">
                                        <div className="flex items-center">
                                          <span className="text-2xl mr-3 text-black-400">
                                            {/* SVG Icon */}
                                          </span>
                                          <div>
                                            <h6 className="font-medium text-sm text-black-600">
                                              {option.name || "Shipping Option"}{" "}
                                              {/* Option name */}
                                            </h6>
                                            <p className="text-xs text-black-500 font-semibold font-medium">
                                              <span className="font-medium text-black-600">
                                                {option.cost
                                                  ? `$ ${option.cost}`
                                                  : " $ 0"}
                                              </span>
                                            </p>
                                          </div>
                                        </div>
                                        <span className="text-black-600 font-medium">
                                          {formik.values.shippingOption ===
                                            option.id
                                            ? "Selected"
                                            : ""}
                                        </span>
                                      </div>
                                    </label>
                                  </div>
                                </div>
                              ))}
                        </div>

                        {formik.errors.shippingOption &&
                          formik.touched.shippingOption && (
                            <span className="text-red-400 text-sm mt-2">
                              {formik.errors.shippingOption}
                            </span>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="lg:col-span-1 lg:mr-6">
                  <OrderSummary class
                    shippingCost={shippingCostNew}
                    threshold={shippingThreshhold}
                    formik={formik}
                  />
                  <div className=" w-full lg:ml-14  mx-auto mt-8 bg-white shadow-lg rounded-xl overflow-hidden border border-black-100">
                    {/* Header */}
                    <div className="bg-black-50 px-6 py-4 border-b border-black-200">
                      <h2 className="text-lg font-semibold text-black-800">
                        Payment Details
                      </h2>
                      <p className="text-sm text-black-500 font-semibold">
                        Secure payment with SSL encryption
                      </p>
                    </div>

                    {/* Form Content */}
                    <div className="p-6 space-y-5">
                      {/* Payment Method */}
                      <div>
                        <label
                          htmlFor="paymentMethod"
                          className="block text-sm font-medium text-black-700 mb-1"
                        >
                          Payment Method <span className="text-red-500">*</span>
                        </label>
                        <select
                          id="paymentMethod"
                          name="paymentMethod"
                          value={formik.values.paymentMethod}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          className={`block w-full rounded-lg border ${formik.touched.paymentMethod &&
                            formik.errors.paymentMethod
                            ? "border-red-500"
                            : "border-black-300"
                            } bg-white py-2 px-3 text-sm shadow-sm focus:border-emerald-500 focus:ring-emerald-500`}
                        >
                          <option value="">Select payment method</option>
                          <option value="credit card">💳 Credit Card</option>
                        </select>
                        {formik.touched.paymentMethod &&
                          formik.errors.paymentMethod && (
                            <p className="text-red-500 text-xs mt-1">
                              {formik.errors.paymentMethod}
                            </p>
                          )}
                      </div>

                      {/* Card Number */}
                      <div>
                        <label
                          htmlFor="cardNumber"
                          className="block text-sm font-medium text-black-700 mb-1"
                        >
                          Card Number <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          id="cardNumber"
                          name="cardNumber"
                          placeholder="1234 5678 9012 3456"
                          value={formik.values.cardNumber}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          className={`block w-full rounded-lg border ${formik.touched.cardNumber &&
                            formik.errors.cardNumber
                            ? "border-red-500"
                            : "border-black-300"
                            } py-2 px-3 text-sm shadow-sm focus:border-emerald-500 focus:ring-emerald-500`}
                        />
                        {formik.touched.cardNumber &&
                          formik.errors.cardNumber && (
                            <p className="text-red-500 text-xs mt-1">
                              {formik.errors.cardNumber}
                            </p>
                          )}
                      </div>

                      {/* Expiration & CVV */}
                      <div className="grid grid-cols-2 gap-4">
                        <div>
                          <label
                            htmlFor="expirationDate"
                            className="block text-sm font-medium text-black-700 mb-1"
                          >
                            Expiration (MM/YY){" "}
                            <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="text"
                            id="expirationDate"
                            name="expirationDate"
                            placeholder="MM/YY"
                            maxLength={5} // Prevent extra characters
                            value={formik.values.expirationDate}
                            onChange={(e) => {
                              let value = e.target.value.replace(/\D/g, ""); // Remove non-numeric chars
                              if (value.length >= 3) {
                                value =
                                  value.slice(0, 2) + "/" + value.slice(2, 4);
                              }
                              formik.setFieldValue("expirationDate", value);
                            }}
                            onBlur={formik.handleBlur}
                            className={`block w-full rounded-lg border ${formik.touched.expirationDate &&
                              formik.errors.expirationDate
                              ? "border-red-500"
                              : "border-black-300"
                              } py-2 px-3 text-sm shadow-sm focus:border-emerald-500 focus:ring-emerald-500`}
                          />
                          {formik.touched.expirationDate &&
                            formik.errors.expirationDate && (
                              <p className="text-red-500 text-xs mt-1">
                                {formik.errors.expirationDate}
                              </p>
                            )}
                        </div>

                        <div>
                          <label
                            htmlFor="securityCode"
                            className="block text-sm font-medium text-black-700 mb-1 "
                          >
                            CVV <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="password"
                            id="securityCode"
                            name="securityCode"
                            placeholder="•••"
                            value={formik.values.securityCode}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            className={`block w-full rounded-lg border ${formik.touched.securityCode &&
                              formik.errors.securityCode
                              ? "border-red-500"
                              : "border-black-300"
                              } py-2 px-3 text-sm shadow-sm focus:border-emerald-500 focus:ring-emerald-500`}
                          />
                          {formik.touched.securityCode &&
                            formik.errors.securityCode && (
                              <p className="text-red-500 text-xs mt-1">
                                {formik.errors.securityCode}
                              </p>
                            )}
                        </div>
                      </div>

                      {/* Pay Button */}
                    <div className="col-span-6 sm:col-span-3">

  <button
    type="submit"
    id="checkout-button"
    disabled={isProcessing}

    // {/* Original Age Verification */}
    
    // onClick={() => {
    //   const hiddenTrigger = document.getElementById("fake-age-checker");

    //   if (hiddenTrigger) {
    //     hiddenTrigger.click();
    //   }
    // }}
    
    onClick={handleRedirect}
    className={`${
      isProcessing
        ? "bg-gray-400 cursor-not-allowed border-gray-400"
        : "bg-emerald-500 hover:bg-emerald-600 border-emerald-500"
    } transition-all rounded py-3 text-center text-sm font-medium text-white flex justify-center items-center w-full`}
  >
    {isProcessing ? (
      <>
        <svg
          className="animate-spin h-5 w-5 mr-2"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />

          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v8H4z"
          />
        </svg>

        Please wait...
      </>
    ) : (
      <>
        Place Order

        <span className="text-xl ml-2">
          <svg
            stroke="currentColor"
            fill="currentColor"
            strokeWidth="0"
            viewBox="0 0 512 512"
            height="1em"
            width="1em"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="48"
              d="M268 112l144 144-144 144m124-144H100"
            />
          </svg>
        </span>
      </>
    )}

    <div id="fake-age-checker" style={{ display: "none" }}></div>
  </button>

  {redirectMessage && (
    <div className="mt-4 rounded-lg border border-emerald-500 bg-emerald-50 p-4 text-center ">
     <p className="text-emerald-700 font-semibold text-lg">
  🎉 Great News! This exact product is available on{" "}
  <span className="font-bold underline">Smokeprawns.com</span>{" "}
  at the <span className="text-emerald-800">same price</span>.
</p>

<p className="mt-2 text-sm text-emerald-600">
  ✔️ Shop directly from our official store for the latest stock, exclusive offers, and fast delivery.
</p>
    </div>
  )}

</div>


                    </div>
                  </div>
                </div>
              </div>

              {/* --------------------------------------card details-------------------- */}

              {/* ----------------- Payment Details Section ----------------- */}

              {/* <div className="grid grid-cols-6 gap-4 lg:gap-6 mt-10">
                <div className="col-span-6 sm:col-span-3">
                  <Link
                    className="bg-indigo-50 border !no-underline border-indigo-100 rounded py-3 text-center text-sm font-medium !text-black-700  hover:!text-black-800 hover:border-black-300 transition-all flex justify-center w-full"
                    to="/"
                  >
                    <span className="text-xl mr-2">
                      <svg
                        stroke="currentColor"
                        fill="currentColor"
                        strokeWidth="0"
                        viewBox="0 0 512 512"
                        height="1em"
                        width="1em"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="32"
                          d="M112 160l-64 64 64 64"
                        ></path>
                        <path
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="32"
                          d="M64 224h294c58.76 0 106 49.33 106 108v20"
                        ></path>
                      </svg>
                    </span>
                    Continue Shopping
                  </Link>
                </div>
              </div> */}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Checkout;
